/**
 * this file contains all redux-saga watchers & workers (like separate threads)
 * - watchers watch for dispatched actions
 * - workers invoke another actions in response to the processed actions
 *
 * NOTE: Saga's use the new ES6 generator functions function* ()
 * NOTE: Arrow-function can not be used as generators as the yield keyword
 * may not work in an arrow function's body
 *
 * Created by Tom on 18/06/18
 */

import { all } from 'redux-saga/effects'

// import sagas
import * as FundsSummarySaga from './sagas/fundsSummarySaga'
import * as FundSaga from './sagas/fundSaga'
import * as DocumentsSaga from './sagas/documentsSaga'
import * as ReportSaga from './sagas/reportSaga'
import * as BillingSaga from './sagas/billingSaga'


/* -----------------------------------------------------------------------------
    ROOT SAGA
----------------------------------------------------------------------------- */

// this root saga groups all other watcher sagas together
export default function* rootSaga() {
    yield all([
        
        FundsSummarySaga.watchFetchFundsSummary(),
        FundsSummarySaga.watchFetchFundsList(),
        
        FundSaga.watchCreateFund(),
        FundSaga.watchUpdateFund(),
        FundSaga.watchFetchFund(),
        FundSaga.watchFetchInProgressFund(),
        FundSaga.watchFetchFundSummary(),

        FundSaga.watchFetchFundOverallSummary(),
        FundSaga.watchFetchDetailedAssetPosition(),
        FundSaga.watchFetchCashReconciliation(),
        FundSaga.watchRequestBusinessEvents(),
        FundSaga.watchRequestCorporateActions(),
        FundSaga.watchFetchFundContributions(),

        DocumentsSaga.watchFetchDocumentsData(),
        DocumentsSaga.watchDeleteDocument(),
        DocumentsSaga.watchFetchDocumentCategories(),
        DocumentsSaga.watchFetchDocusignData(),

        ReportSaga.watchRequestReport(),

        BillingSaga.watchFetchBillingData(),
    ])
}


// WEBPACK FOOTER //
// ./src/sagas.js